[
  {
    "id": 1,
    "industrial_area_id": 2,
    "latitude": 24.9786301,
    "longitude": 55.1685973,
    "name": "Premier Composite Technologies (PCT HQ)",
    "slug": "premier-composite-technologies-pct-hq"
  },
  {
    "id": 2,
    "industrial_area_id": 2,
    "latitude": 24.9809402,
    "longitude": 55.2074592,
    "name": "Nova Composites Manufacturing LLC",
    "slug": "nova-composites-manufacturing-llc"
  },
  {
    "id": 3,
    "industrial_area_id": 28,
    "latitude": 24.2861125,
    "longitude": 55.6200886,
    "name": "Strata Manufacturing",
    "slug": "strata-manufacturing"
  },
  {
    "id": 4,
    "industrial_area_id": 17,
    "latitude": 25.4651755,
    "longitude": 55.5076307,
    "name": "Enata Industries",
    "slug": "enata-industries"
  },
  {
    "id": 5,
    "industrial_area_id": 22,
    "latitude": 25.5552093,
    "longitude": 55.712237,
    "name": "Lloyds Composites",
    "slug": "lloyds-composites"
  },
  {
    "id": 6,
    "industrial_area_id": 23,
    "latitude": 25.6755965,
    "longitude": 55.8040812,
    "name": "Spatial Composite Solutions FZ LLC",
    "slug": "spatial-composite-solutions-fz-llc"
  },
  {
    "id": 7,
    "industrial_area_id": 5,
    "latitude": 24.9810981,
    "longitude": 55.1203673,
    "name": "SFG Composites",
    "slug": "sfg-composites"
  },
  {
    "id": 8,
    "industrial_area_id": 9,
    "latitude": 25.1262413,
    "longitude": 55.2396937,
    "name": "Advanced Fiberglass Industries",
    "slug": "advanced-fiberglass-industries"
  },
  {
    "id": 9,
    "industrial_area_id": 1,
    "latitude": 24.8589645,
    "longitude": 55.0626919,
    "name": "Leaders Plastic Manufacturing LLC",
    "slug": "leaders-plastic-manufacturing-llc"
  },
  {
    "id": 10,
    "industrial_area_id": 1,
    "latitude": 24.8578275,
    "longitude": 55.0587367,
    "name": "Mechatech Industries LLC",
    "slug": "mechatech-industries-llc"
  },
  {
    "id": 11,
    "industrial_area_id": 2,
    "latitude": 24.9748947,
    "longitude": 55.1489817,
    "name": "Modern Plastic Industry LLC (DIP)",
    "slug": "modern-plastic-industry-llc-dip"
  },
  {
    "id": 12,
    "industrial_area_id": 5,
    "latitude": 24.9969936,
    "longitude": 55.0997383,
    "name": "Malibu Plastic Industries",
    "slug": "malibu-plastic-industries"
  },
  {
    "id": 13,
    "industrial_area_id": 9,
    "latitude": 25.1307003,
    "longitude": 55.2228401,
    "name": "Precision Plastic Products Company LLC",
    "slug": "precision-plastic-products-company-llc"
  },
  {
    "id": 14,
    "industrial_area_id": 20,
    "latitude": 25.4372894,
    "longitude": 55.5493037,
    "name": "HI Tech Plastic Industries L.l.c",
    "slug": "hi-tech-plastic-industries-l-l-c"
  },
  {
    "id": 15,
    "industrial_area_id": 32,
    "latitude": 24.2775732,
    "longitude": 54.4802137,
    "name": "Cristal Plastic Industrial Llc.",
    "slug": "cristal-plastic-industrial-llc"
  },
  {
    "id": 16,
    "industrial_area_id": 7,
    "latitude": 24.9771223,
    "longitude": 55.0809555,
    "name": "Nuplas Industries Fzco - North Zone",
    "slug": "nuplas-industries-fzco-north-zone"
  },
  {
    "id": 17,
    "industrial_area_id": 30,
    "latitude": 24.714023,
    "longitude": 54.7347546,
    "name": "Polyfab Plastic Industry LLC Kizad ABU Dhabi",
    "slug": "polyfab-plastic-industry-llc-kizad-abu-dhabi"
  },
  {
    "id": 18,
    "industrial_area_id": 14,
    "latitude": 25.3158437,
    "longitude": 55.3889704,
    "name": "Interplast Co. Ltd. (head Office)",
    "slug": "interplast-co-ltd-head-office"
  },
  {
    "id": 19,
    "industrial_area_id": 5,
    "latitude": 25.0031881,
    "longitude": 55.1245269,
    "name": "Proto21 3d Printing LLC",
    "slug": "proto21-3d-printing-llc"
  },
  {
    "id": 20,
    "industrial_area_id": 5,
    "latitude": 24.9962826,
    "longitude": 55.1111239,
    "name": "3distica",
    "slug": "3distica"
  },
  {
    "id": 21,
    "industrial_area_id": 2,
    "latitude": 24.9708857,
    "longitude": 55.1909702,
    "name": "Ultratec 3d Printing",
    "slug": "ultratec-3d-printing"
  },
  {
    "id": 22,
    "industrial_area_id": 2,
    "latitude": 24.9737972,
    "longitude": 55.1875861,
    "name": "Layerx 3d Printing Products Production Co.",
    "slug": "layerx-3d-printing-products-production-co"
  },
  {
    "id": 23,
    "industrial_area_id": 9,
    "latitude": 25.1336144,
    "longitude": 55.2247352,
    "name": "Generation 3d",
    "slug": "generation-3d"
  },
  {
    "id": 24,
    "industrial_area_id": 9,
    "latitude": 25.1868047,
    "longitude": 55.2587981,
    "name": "3d Systems Middle East",
    "slug": "3d-systems-middle-east"
  },
  {
    "id": 25,
    "industrial_area_id": 5,
    "latitude": 24.9870537,
    "longitude": 55.1184628,
    "name": "Paradigm 3d",
    "slug": "paradigm-3d"
  },
  {
    "id": 26,
    "industrial_area_id": 10,
    "latitude": 25.2286396,
    "longitude": 55.3738664,
    "name": "Maptec",
    "slug": "maptec"
  },
  {
    "id": 27,
    "industrial_area_id": 23,
    "latitude": 25.6858412,
    "longitude": 55.790205,
    "name": "Falcon Technologies International LLC",
    "slug": "falcon-technologies-international-llc"
  },
  {
    "id": 28,
    "industrial_area_id": 2,
    "latitude": 25.0513246,
    "longitude": 55.1327515,
    "name": "Perfect Tools Moulds Factory L.l.c",
    "slug": "perfect-tools-moulds-factory-l-l-c"
  },
  {
    "id": 29,
    "industrial_area_id": 12,
    "latitude": 25.1716226,
    "longitude": 55.3551029,
    "name": "Automech Engineering Company LLC",
    "slug": "automech-engineering-company-llc"
  },
  {
    "id": 30,
    "industrial_area_id": 1,
    "latitude": 24.8469482,
    "longitude": 55.0574332,
    "name": "AL Shurooq Industries LLC",
    "slug": "al-shurooq-industries-llc"
  },
  {
    "id": 31,
    "industrial_area_id": 2,
    "latitude": 24.9866514,
    "longitude": 55.1434898,
    "name": "AL Mufilh Eng.turning LLC - Dubai",
    "slug": "al-mufilh-eng-turning-llc-dubai"
  },
  {
    "id": 32,
    "industrial_area_id": 9,
    "latitude": 25.1158245,
    "longitude": 55.214409,
    "name": "Trinity Mechanical Services LLC Branch",
    "slug": "trinity-mechanical-services-llc-branch"
  },
  {
    "id": 33,
    "industrial_area_id": 9,
    "latitude": 25.1489292,
    "longitude": 55.2298539,
    "name": "Micron Machining LLC",
    "slug": "micron-machining-llc"
  },
  {
    "id": 34,
    "industrial_area_id": 29,
    "latitude": 24.5588232,
    "longitude": 54.7354544,
    "name": "EPI",
    "slug": "epi"
  },
  {
    "id": 35,
    "industrial_area_id": 2,
    "latitude": 24.9766612,
    "longitude": 55.2056285,
    "name": "Falcon Mechanical Services LLC",
    "slug": "falcon-mechanical-services-llc"
  },
  {
    "id": 36,
    "industrial_area_id": 10,
    "latitude": 25.2300367,
    "longitude": 55.354248,
    "name": "Fimx Mechanical Services",
    "slug": "fimx-mechanical-services"
  },
  {
    "id": 37,
    "industrial_area_id": 9,
    "latitude": 25.1118769,
    "longitude": 55.2314283,
    "name": "Mighty Precision Machining",
    "slug": "mighty-precision-machining"
  },
  {
    "id": 38,
    "industrial_area_id": 11,
    "latitude": 25.2645125,
    "longitude": 55.2638517,
    "name": "Metalock Engineering AE",
    "slug": "metalock-engineering-ae"
  },
  {
    "id": 39,
    "industrial_area_id": 17,
    "latitude": 25.4393258,
    "longitude": 55.5727951,
    "name": "Flowline Mechanical Engineering FZC",
    "slug": "flowline-mechanical-engineering-fzc"
  },
  {
    "id": 40,
    "industrial_area_id": 5,
    "latitude": 25.0069054,
    "longitude": 55.1197409,
    "name": "Triotech Dies AND Tools MFG LLC",
    "slug": "triotech-dies-and-tools-mfg-llc"
  },
  {
    "id": 41,
    "industrial_area_id": 2,
    "latitude": 24.9743674,
    "longitude": 55.1484671,
    "name": "Aswan International Engineering Co. LLC",
    "slug": "aswan-international-engineering-co-llc"
  },
  {
    "id": 42,
    "industrial_area_id": 2,
    "latitude": 24.9897312,
    "longitude": 55.1442648,
    "name": "Accurate Edge Manufacturing & Coating LLC",
    "slug": "accurate-edge-manufacturing-coating-llc"
  },
  {
    "id": 43,
    "industrial_area_id": 15,
    "latitude": 25.3445339,
    "longitude": 55.5000964,
    "name": "Advanced Armour Engineering",
    "slug": "advanced-armour-engineering"
  },
  {
    "id": 44,
    "industrial_area_id": 7,
    "latitude": 24.9650508,
    "longitude": 55.0629511,
    "name": "Fabtech International Limited",
    "slug": "fabtech-international-limited"
  },
  {
    "id": 45,
    "industrial_area_id": 1,
    "latitude": 24.825389,
    "longitude": 55.0863644,
    "name": "Franz & Olsen Engineering Services",
    "slug": "franz-olsen-engineering-services"
  },
  {
    "id": 46,
    "industrial_area_id": 2,
    "latitude": 24.9877605,
    "longitude": 55.1605186,
    "name": "Florida Global Technical Services LLC",
    "slug": "florida-global-technical-services-llc"
  },
  {
    "id": 47,
    "industrial_area_id": 2,
    "latitude": 24.9844151,
    "longitude": 55.2089983,
    "name": "Hidayath Group",
    "slug": "hidayath-group"
  },
  {
    "id": 48,
    "industrial_area_id": 17,
    "latitude": 25.4513094,
    "longitude": 55.4986459,
    "name": "Lefebvre Engineering FZC",
    "slug": "lefebvre-engineering-fzc"
  },
  {
    "id": 49,
    "industrial_area_id": 7,
    "latitude": 24.9523931,
    "longitude": 55.0984146,
    "name": "Acme Intralog Fzco",
    "slug": "acme-intralog-fzco"
  },
  {
    "id": 50,
    "industrial_area_id": 7,
    "latitude": 24.9635454,
    "longitude": 55.0687174,
    "name": "Eurotech Metal",
    "slug": "eurotech-metal"
  },
  {
    "id": 51,
    "industrial_area_id": 7,
    "latitude": 24.9608592,
    "longitude": 55.0684628,
    "name": "3c Metal Middle East FZE",
    "slug": "3c-metal-middle-east-fze"
  },
  {
    "id": 52,
    "industrial_area_id": 3,
    "latitude": 24.9358225,
    "longitude": 55.050621,
    "name": "Advanced Metal Works Fze(bin Ghatti Industries)",
    "slug": "advanced-metal-works-fze-bin-ghatti-industries"
  },
  {
    "id": 53,
    "industrial_area_id": 9,
    "latitude": 25.1108083,
    "longitude": 55.22517,
    "name": "Sunshine Metal Works LLC",
    "slug": "sunshine-metal-works-llc"
  },
  {
    "id": 54,
    "industrial_area_id": 9,
    "latitude": 25.1314008,
    "longitude": 55.2401662,
    "name": "Gulf Metal Foundry",
    "slug": "gulf-metal-foundry"
  },
  {
    "id": 55,
    "industrial_area_id": 5,
    "latitude": 24.9861165,
    "longitude": 55.1314887,
    "name": "Blue Light Industry (foundry)",
    "slug": "blue-light-industry-foundry"
  },
  {
    "id": 56,
    "industrial_area_id": 23,
    "latitude": 25.6601367,
    "longitude": 55.797215,
    "name": "Integrated Industries (2i)",
    "slug": "integrated-industries-2i"
  },
  {
    "id": 57,
    "industrial_area_id": 12,
    "latitude": 25.1818539,
    "longitude": 55.3435766,
    "name": "Aladdin Container CO L.l.c",
    "slug": "aladdin-container-co-l-l-c"
  },
  {
    "id": 58,
    "industrial_area_id": 9,
    "latitude": 25.130463,
    "longitude": 55.2452841,
    "name": "Precision Industries",
    "slug": "precision-industries"
  },
  {
    "id": 59,
    "industrial_area_id": 29,
    "latitude": 24.55911,
    "longitude": 54.8854713,
    "name": "Halcon- Office",
    "slug": "halcon-office"
  },
  {
    "id": 60,
    "industrial_area_id": 5,
    "latitude": 25.0234247,
    "longitude": 55.0798022,
    "name": "Gulf Extrusions",
    "slug": "gulf-extrusions"
  },
  {
    "id": 61,
    "industrial_area_id": 14,
    "latitude": 25.2873842,
    "longitude": 55.4431105,
    "name": "Intercare Limited",
    "slug": "intercare-limited"
  },
  {
    "id": 62,
    "industrial_area_id": 2,
    "latitude": 24.9845393,
    "longitude": 55.1644297,
    "name": "AL Nawras Metal Coating",
    "slug": "al-nawras-metal-coating"
  },
  {
    "id": 63,
    "industrial_area_id": 2,
    "latitude": 24.9831941,
    "longitude": 55.2116842,
    "name": "Svrs Precision Dies Manufacturing LLC",
    "slug": "svrs-precision-dies-manufacturing-llc"
  },
  {
    "id": 64,
    "industrial_area_id": 28,
    "latitude": 24.2752313,
    "longitude": 55.6003524,
    "name": "Ammroc",
    "slug": "ammroc"
  },
  {
    "id": 147,
    "industrial_area_id": 7,
    "latitude": 24.9639121,
    "longitude": 55.0210953,
    "name": "Ducab",
    "slug": "ducab"
  },
  {
    "id": 148,
    "industrial_area_id": 14,
    "latitude": 25.3106424,
    "longitude": 55.4342189,
    "name": "Tekab Co. Ltd.",
    "slug": "tekab-co-ltd"
  },
  {
    "id": 149,
    "industrial_area_id": 25,
    "latitude": 25.3944213,
    "longitude": 55.9760499,
    "name": "Middle East Specialized Cables RAK",
    "slug": "middle-east-specialized-cables-rak"
  },
  {
    "id": 150,
    "industrial_area_id": 16,
    "latitude": 25.3003488,
    "longitude": 55.6029102,
    "name": "National Cables Industry",
    "slug": "national-cables-industry"
  },
  {
    "id": 151,
    "industrial_area_id": 35,
    "latitude": 25.0842902,
    "longitude": 56.2966264,
    "name": "Power Plus Cable Co. L.l.c",
    "slug": "power-plus-cable-co-l-l-c"
  },
  {
    "id": 152,
    "industrial_area_id": 31,
    "latitude": 24.343164,
    "longitude": 54.4759501,
    "name": "ABU Dhabi Cable Factory",
    "slug": "abu-dhabi-cable-factory"
  },
  {
    "id": 153,
    "industrial_area_id": 22,
    "latitude": 25.5586565,
    "longitude": 55.7166314,
    "name": "Arabian Fiber Optic Cable Manufacturing LLC",
    "slug": "arabian-fiber-optic-cable-manufacturing-llc"
  },
  {
    "id": 154,
    "industrial_area_id": 23,
    "latitude": 25.6647586,
    "longitude": 55.7955698,
    "name": "RAS AL Khaimah Cables LLC",
    "slug": "ras-al-khaimah-cables-llc"
  },
  {
    "id": 155,
    "industrial_area_id": 7,
    "latitude": 24.9625545,
    "longitude": 55.0605293,
    "name": "WPS World Power Solution",
    "slug": "wps-world-power-solution"
  },
  {
    "id": 156,
    "industrial_area_id": 7,
    "latitude": 24.9639015,
    "longitude": 55.0623474,
    "name": "Adpower Fzco",
    "slug": "adpower-fzco"
  },
  {
    "id": 157,
    "industrial_area_id": 15,
    "latitude": 25.3477296,
    "longitude": 55.485398,
    "name": "Technopower FZC",
    "slug": "technopower-fzc"
  },
  {
    "id": 158,
    "industrial_area_id": 17,
    "latitude": 25.440625,
    "longitude": 55.5767051,
    "name": "Rich Motor Company (FZE)",
    "slug": "rich-motor-company-fze"
  },
  {
    "id": 159,
    "industrial_area_id": 15,
    "latitude": 25.3303708,
    "longitude": 55.4834404,
    "name": "Ultra Power Generators FZC",
    "slug": "ultra-power-generators-fzc"
  },
  {
    "id": 160,
    "industrial_area_id": 2,
    "latitude": 24.978063,
    "longitude": 55.1685158,
    "name": "Bahmani Manufacturing AND Industrial Technology",
    "slug": "bahmani-manufacturing-and-industrial-technology"
  },
  {
    "id": 161,
    "industrial_area_id": 2,
    "latitude": 24.9681568,
    "longitude": 55.1743202,
    "name": "Express Power Generators LLC",
    "slug": "express-power-generators-llc"
  },
  {
    "id": 162,
    "industrial_area_id": 7,
    "latitude": 24.9627343,
    "longitude": 55.0719118,
    "name": "Jubaili Bros SAL - Genset Manufacturing",
    "slug": "jubaili-bros-sal-genset-manufacturing"
  },
  {
    "id": 163,
    "industrial_area_id": 5,
    "latitude": 24.9639423,
    "longitude": 55.0905684,
    "name": "FG Wilson (engineering) FZE",
    "slug": "fg-wilson-engineering-fze"
  },
  {
    "id": 164,
    "industrial_area_id": 5,
    "latitude": 24.9664764,
    "longitude": 55.1058937,
    "name": "Rolls-royce Solutions Middle East FZE",
    "slug": "rolls-royce-solutions-middle-east-fze"
  },
  {
    "id": 165,
    "industrial_area_id": 5,
    "latitude": 24.9710165,
    "longitude": 55.0942871,
    "name": "Atlas Copco Middle East FZE",
    "slug": "atlas-copco-middle-east-fze"
  },
  {
    "id": 166,
    "industrial_area_id": 11,
    "latitude": 25.2626449,
    "longitude": 55.2610019,
    "name": "AL Masaood Volvo Penta",
    "slug": "al-masaood-volvo-penta"
  },
  {
    "id": 167,
    "industrial_area_id": 7,
    "latitude": 24.9650271,
    "longitude": 55.0775827,
    "name": "AGG Power Technology & Solutions ME Fzco",
    "slug": "agg-power-technology-solutions-me-fzco"
  },
  {
    "id": 168,
    "industrial_area_id": 7,
    "latitude": 24.9860138,
    "longitude": 55.0882573,
    "name": "Himoinsa Middle East",
    "slug": "himoinsa-middle-east"
  },
  {
    "id": 169,
    "industrial_area_id": 7,
    "latitude": 24.9964235,
    "longitude": 55.0886813,
    "name": "Emirates Transformer & Switchgear Limited",
    "slug": "emirates-transformer-switchgear-limited"
  },
  {
    "id": 170,
    "industrial_area_id": 17,
    "latitude": 25.4557399,
    "longitude": 55.5008278,
    "name": "Eurogulf Transformer FZE",
    "slug": "eurogulf-transformer-fze"
  },
  {
    "id": 171,
    "industrial_area_id": 22,
    "latitude": 25.5034737,
    "longitude": 55.5505418,
    "name": "Abaft Middle East Transformers IND LLC",
    "slug": "abaft-middle-east-transformers-ind-llc"
  },
  {
    "id": 172,
    "industrial_area_id": 31,
    "latitude": 24.3575381,
    "longitude": 54.4751481,
    "name": "Federal Transformers Company LLC",
    "slug": "federal-transformers-company-llc"
  },
  {
    "id": 173,
    "industrial_area_id": 27,
    "latitude": 24.059434,
    "longitude": 55.4371497,
    "name": "Tesar Gulf.",
    "slug": "tesar-gulf"
  },
  {
    "id": 174,
    "industrial_area_id": 14,
    "latitude": 25.2904131,
    "longitude": 55.4224991,
    "name": "AL Budoor Elect. Transformers Ind. LLC",
    "slug": "al-budoor-elect-transformers-ind-llc"
  },
  {
    "id": 175,
    "industrial_area_id": 7,
    "latitude": 24.9522142,
    "longitude": 55.059143,
    "name": "Global Transformers & Switchgear F Z C O",
    "slug": "global-transformers-switchgear-f-z-c-o"
  },
  {
    "id": 176,
    "industrial_area_id": 2,
    "latitude": 24.9708515,
    "longitude": 55.191514,
    "name": "Core & Coil Transformers Assembling LLC",
    "slug": "core-coil-transformers-assembling-llc"
  },
  {
    "id": 177,
    "industrial_area_id": 7,
    "latitude": 24.9589021,
    "longitude": 55.0584243,
    "name": "Beta Transformers Fzco",
    "slug": "beta-transformers-fzco"
  },
  {
    "id": 178,
    "industrial_area_id": 32,
    "latitude": 24.2966157,
    "longitude": 54.4646002,
    "name": "1",
    "slug": "1"
  },
  {
    "id": 179,
    "industrial_area_id": 16,
    "latitude": 25.3309636,
    "longitude": 55.6298921,
    "name": "Intact Controls Transformer Industries LLC",
    "slug": "intact-controls-transformer-industries-llc"
  },
  {
    "id": 180,
    "industrial_area_id": 17,
    "latitude": 25.4432946,
    "longitude": 55.5802619,
    "name": "Royal Gold International FZE",
    "slug": "royal-gold-international-fze"
  },
  {
    "id": 181,
    "industrial_area_id": 2,
    "latitude": 25.077361,
    "longitude": 55.1471471,
    "name": "ADC Energy Systems LLC",
    "slug": "adc-energy-systems-llc"
  },
  {
    "id": 182,
    "industrial_area_id": 14,
    "latitude": 25.2864943,
    "longitude": 55.4423976,
    "name": "Arabian Gulf Switchgear LLC",
    "slug": "arabian-gulf-switchgear-llc"
  },
  {
    "id": 183,
    "industrial_area_id": 14,
    "latitude": 25.2927929,
    "longitude": 55.4195126,
    "name": "System Elect. Transformer Ind. LLC",
    "slug": "system-elect-transformer-ind-llc"
  },
  {
    "id": 184,
    "industrial_area_id": 7,
    "latitude": 24.9749007,
    "longitude": 55.0784921,
    "name": "Lucy Switchgear FZE",
    "slug": "lucy-switchgear-fze"
  },
  {
    "id": 185,
    "industrial_area_id": 31,
    "latitude": 24.3424155,
    "longitude": 54.3316128,
    "name": "Scientechnic",
    "slug": "scientechnic"
  },
  {
    "id": 186,
    "industrial_area_id": 32,
    "latitude": 24.297975,
    "longitude": 54.4783031,
    "name": "Federal Switchgears",
    "slug": "federal-switchgears"
  },
  {
    "id": 187,
    "industrial_area_id": 2,
    "latitude": 24.9715697,
    "longitude": 55.1626546,
    "name": "AL Fanar Electric (l. L. C)",
    "slug": "al-fanar-electric-l-l-c"
  },
  {
    "id": 188,
    "industrial_area_id": 7,
    "latitude": 24.9585238,
    "longitude": 55.0717421,
    "name": "Farraj Trading & Manufacturing Co.",
    "slug": "farraj-trading-manufacturing-co"
  },
  {
    "id": 189,
    "industrial_area_id": 7,
    "latitude": 24.9551255,
    "longitude": 55.0699199,
    "name": "Schneider Electric Supplychain",
    "slug": "schneider-electric-supplychain"
  },
  {
    "id": 190,
    "industrial_area_id": 3,
    "latitude": 24.9301238,
    "longitude": 55.0566987,
    "name": "Eaton FZE Middle East HQ",
    "slug": "eaton-fze-middle-east-hq"
  },
  {
    "id": 191,
    "industrial_area_id": 7,
    "latitude": 24.957549,
    "longitude": 55.0873711,
    "name": "Masseera Industrial Switchgear FZE",
    "slug": "masseera-industrial-switchgear-fze"
  },
  {
    "id": 192,
    "industrial_area_id": 14,
    "latitude": 25.2869085,
    "longitude": 55.4404616,
    "name": "Start Electrical Switchgear LLC",
    "slug": "start-electrical-switchgear-llc"
  },
  {
    "id": 193,
    "industrial_area_id": 12,
    "latitude": 25.238734,
    "longitude": 55.3653951,
    "name": "Prime Electrical Manufacturing (l.l.c)",
    "slug": "prime-electrical-manufacturing-l-l-c"
  },
  {
    "id": 194,
    "industrial_area_id": 14,
    "latitude": 25.2990016,
    "longitude": 55.4210054,
    "name": "AL Terhab Elect Switchgear Dist LLC",
    "slug": "al-terhab-elect-switchgear-dist-llc"
  },
  {
    "id": 195,
    "industrial_area_id": 2,
    "latitude": 24.9751411,
    "longitude": 55.1840906,
    "name": "Voltronix Switchgear LLC",
    "slug": "voltronix-switchgear-llc"
  },
  {
    "id": 196,
    "industrial_area_id": 12,
    "latitude": 25.1791402,
    "longitude": 55.3688053,
    "name": "Power Plus Electrical Switchgear",
    "slug": "power-plus-electrical-switchgear"
  },
  {
    "id": 197,
    "industrial_area_id": 3,
    "latitude": 24.9343166,
    "longitude": 55.0530472,
    "name": "Safety Electrical Switchgear Manufacturing LLC",
    "slug": "safety-electrical-switchgear-manufacturing-llc"
  },
  {
    "id": 198,
    "industrial_area_id": 14,
    "latitude": 25.2826362,
    "longitude": 55.4454762,
    "name": "Binghalib Engineering",
    "slug": "binghalib-engineering"
  },
  {
    "id": 199,
    "industrial_area_id": 31,
    "latitude": 24.3324563,
    "longitude": 54.5128446,
    "name": "Power Economy Middle East CO LLC",
    "slug": "power-economy-middle-east-co-llc"
  },
  {
    "id": 200,
    "industrial_area_id": 18,
    "latitude": 25.4131948,
    "longitude": 55.451363,
    "name": "Accurate Control Switchgear FZE",
    "slug": "accurate-control-switchgear-fze"
  },
  {
    "id": 201,
    "industrial_area_id": 18,
    "latitude": 25.4131926,
    "longitude": 55.451642,
    "name": "Powertech Switchgear Office",
    "slug": "powertech-switchgear-office"
  },
  {
    "id": 202,
    "industrial_area_id": 32,
    "latitude": 24.3070989,
    "longitude": 54.4952706,
    "name": "Milectria Middle East Cables LLC",
    "slug": "milectria-middle-east-cables-llc"
  },
  {
    "id": 203,
    "industrial_area_id": 29,
    "latitude": 24.5731795,
    "longitude": 54.8780368,
    "name": "Rockford Xellerix",
    "slug": "rockford-xellerix"
  },
  {
    "id": 204,
    "industrial_area_id": 12,
    "latitude": 25.1814813,
    "longitude": 55.3767321,
    "name": "Optimal Connectivity LLC",
    "slug": "optimal-connectivity-llc"
  },
  {
    "id": 205,
    "industrial_area_id": 13,
    "latitude": 25.1252274,
    "longitude": 55.3777781,
    "name": "Nicomatic Middle East (FZE)",
    "slug": "nicomatic-middle-east-fze"
  },
  {
    "id": 206,
    "industrial_area_id": 31,
    "latitude": 24.3666117,
    "longitude": 54.5177655,
    "name": "Bugraphene Technology & Innovation",
    "slug": "bugraphene-technology-innovation"
  },
  {
    "id": 207,
    "industrial_area_id": 13,
    "latitude": 25.1348914,
    "longitude": 55.381589,
    "name": "Elecaas",
    "slug": "elecaas"
  }
]
